/**
 * Discount display helpers.
 *
 * Products can have an optional `mrp` (list price) OR `discount_pct` set by
 * the admin. Neither actually changes what the customer pays — they're purely
 * visual so we can render a struck-through MRP + "20% OFF" badge next to
 * the real selling price (base_price + tier discounts + selected options).
 */

/**
 * Given a product doc and the current effective per-unit price the customer
 * is being shown, return `{ hasDiscount, mrp, pct }`.
 *
 * `mrp` wins over `discount_pct`; if both are blank we return hasDiscount=false.
 */
export function getDiscountInfo(product, currentUnitPrice) {
  if (!product || !currentUnitPrice || currentUnitPrice <= 0) {
    return { hasDiscount: false, mrp: 0, pct: 0 };
  }
  const rawMrp = Number(product.mrp || 0);
  const rawPct = Number(product.discount_pct || 0);
  let mrp = 0;
  let pct = 0;
  if (rawMrp > currentUnitPrice) {
    mrp = rawMrp;
    pct = Math.round(((rawMrp - currentUnitPrice) / rawMrp) * 100);
  } else if (rawPct > 0 && rawPct < 100) {
    mrp = currentUnitPrice / (1 - rawPct / 100);
    pct = Math.round(rawPct);
  } else {
    return { hasDiscount: false, mrp: 0, pct: 0 };
  }
  return { hasDiscount: pct > 0, mrp: Math.round(mrp * 100) / 100, pct };
}

/** Format a rupee value with Indian grouping ("1,23,456"). */
export function formatRupee(n) {
  const r = Math.round(Number(n || 0));
  return `₹${r.toLocaleString("en-IN")}`;
}
